module.exports = __webpack_public_path__ + "img/lightning_symbol_bw.91abab08.png";